import { Alert, Modal } from 'antd';
import * as React from 'react';

interface TreeMapErrorBoundaryState {
  hasError: boolean;
  visible: boolean;
  error: any;
}

export default class TreeMapErrorBoundary extends React.Component<any, TreeMapErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = {
      error: null,
      hasError: false,
      visible: true,
    };
  }

  static getDerivedStateFromError(error: any) {
    // Mettez à jour l'état, de façon à montrer l'UI de repli au prochain rendu.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    // Vous pouvez aussi enregistrer l'erreur au sein d'un service de rapport.
    console.error(error)
  }

  displayAlert = (error: Error) => {
    return (
      <div>
        <p>{error?.message}</p>
      </div>
    );
  }

  render() {
    const { hasError, visible, error } = this.state;
    if (hasError) {
      return <Modal
        title="Error"
        open={visible}
        onOk={() => this.setState({ visible: false })}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={() => {this.setState({ visible: false })}}
        width={800}
       >
        <Alert
          message="Error"
          description={this.displayAlert(error)}
          type="error"
          showIcon
        />
      </Modal>
    }

    return this.props.children;
  }
}